<template>
  <div class="block text-xxs text-gray-500">
    <ul>
      <li :class="{ 'rule-failed': passwordLengthError }">
        <span v-if="passwordLengthError" class="text-red-500">×</span>
        <span v-else class="rule-passed">✓</span>
        At least 10 characters
      </li>
      <li :class="{ 'rule-failed': passwordDigitsError }">
        <span v-if="passwordDigitsError" class="text-red-500">×</span>
        <span v-else class="rule-passed">✓</span>
        At least 2 numbers
      </li>
      <li :class="{ 'rule-failed': passwordMixLetterCaseError }">
        <span v-if="passwordMixLetterCaseError" class="text-red-500">×</span>
        <span v-else class="rule-passed">✓</span>
        Mix of uppercase and lowercase letters
      </li>
      <li :class="{ 'rule-failed': passwordHaveSymbolError }">
        <span v-if="passwordHaveSymbolError" class="text-red-500">×</span>
        <span v-else class="rule-passed">✓</span>
        At least 1 symbol
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    password: {
      type: String,
    },
  },
  data() {
    return {
      fieldType: 'password',
      passwordLengthError: true,
      passwordDigitsError: true,
      passwordHaveSymbolError: true,
      passwordMixLetterCaseError: true,
    };
  },
  emits: ['validated'],
  methods: {
    passwordChecklist(password) {
      this.passwordLengthError = password.length < 10;
      this.passwordDigitsError = !/\d.*\d/.test(password);
      this.passwordHaveSymbolError = !/\p{Z}|\p{S}|\p{P}/u.test(password);
      this.passwordMixLetterCaseError = !/^(?=.*[a-z])(?=.*[A-Z])/.test(password);
    },
    isValidationFailed() {
      const passwordValidationFailed = [
        this.passwordLengthError,
        this.passwordDigitsError,
        this.passwordHaveSymbolError,
        this.passwordMixLetterCaseError,
      ].some((condition) => condition);
      this.$emit('validated', passwordValidationFailed);
    },
  },
  watch: {
    password: {
      handler(e) {
        this.passwordChecklist(e);
        if (e !== '') this.isValidationFailed();
      },
    },
  },
};
</script>
<style scoped>
.rule-failed {
  color: rgb(254, 37, 87);
}

.rule-passed {
  color: rgb(15, 118, 110);
}
</style>
